import styled from 'styled-components';
import { devices } from '@/UI/Styles/Queries';

export const Wrapper = styled.div`
  padding: 30px 0;
`;

export const FloatingCart = styled.button<{ hasSelection: boolean }>`
  position: fixed;
  z-index: 2;
  top: 8px;
  right: 40px;
  min-width: 50px;
  min-height: 50px;
  width: 50px;
  height: 50px;
  transition: 200ms ease-in-out;
  background-color: ${({ theme, hasSelection }) =>
    hasSelection ? theme.brandTheme.brand100 : theme.migrateColors('background.btnTertiary', 'background')};
  border-radius: 50%;
  cursor: ${({ hasSelection }) => (hasSelection ? 'pointer' : 'default')};
  svg {
    position: absolute;
    top: 10px;
    left: 10px;
    path {
      fill: ${({ theme, hasSelection }) =>
        hasSelection ? theme.migrateColors('icon.inverse', 'white') : theme.brandTheme.brand100};
    }
  }
  @media ${devices.XLarge} {
    right: 55px;
  }
`;

export const ServiceAmount = styled.div`
  position: absolute;
  top: 0;
  left: 32px;
  border-radius: 50%;
  min-width: 22px;
  min-height: 22px;
  width: 22px;
  height: 22px;
  background-color: ${({ theme }) => theme.palette.orange400};
  border: 2px solid ${({ theme }) => theme.palette.white};
  p {
    text-align: center;
    font-size: 14px;
    color: ${({ theme }) => theme.palette.white};
  }
`;
